import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MSI_VALUE, TMsiValueSliceState, TVesselMsiValue, TVesselRecentSales, TSummaryMsiValue, TMsiValue } from './valueTypes';

const initialState: TMsiValueSliceState = {
    vesselListMsiValue: {
        dataList: null,
        loading: false,
        loadingError: null,
    },
    vesselListRecentSales: {
        dataList: null,
        loading: false,
        loadingError: null,
    },
    summaryMsiValue: {
        dataList: null,
        infoNote: '',
        loading: false,
        loadingError: null,
    },
    msiValueState: {
        msiValueData: null,
        loading: false,
        loadingError: null,
    }
};

const valueSlice = createSlice({
    name: MSI_VALUE,
    initialState,
    reducers: {
        getMsiValueRequestAction: (state: TMsiValueSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.msiValueState) {
                state.msiValueState.loadingError = null;
                state.msiValueState.loading = true;
            }
        },
        getMsiValueSuccessAction: (
            state: TMsiValueSliceState,
            { payload: data }: PayloadAction<TMsiValue>,
        ) => {
            if (state.msiValueState) {
                state.msiValueState.msiValueData = data;
                state.msiValueState.loadingError = null;
                state.msiValueState.loading = false;
            }
        },
        getMsiValueErrorAction: (
            state: TMsiValueSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.msiValueState) {
                state.msiValueState.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
                state.msiValueState.loading = false;
            }
        },
        resetMsiValueAction: (state: TMsiValueSliceState) => {
            if (state.msiValueState) {
                state.msiValueState.msiValueData = null;
                state.msiValueState.loadingError = null;
                state.msiValueState.loading = true;
            }
        },

        getVesselMsiValueRequestAction: (state: TMsiValueSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.vesselListMsiValue) {
                state.vesselListMsiValue.loadingError = null;
                state.vesselListMsiValue.loading = true;
            }
        },
        getVesselMsiValueSuccessAction: (
            state: TMsiValueSliceState,
            { payload: data }: PayloadAction<TVesselMsiValue[]>,
        ) => {
            if (state.vesselListMsiValue) {
                state.vesselListMsiValue.dataList = data;
                state.vesselListMsiValue.loading = false;
                state.vesselListMsiValue.loadingError = null;
            }
        },
        getVesselMsiValueErrorAction: (
            state: TMsiValueSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.vesselListMsiValue) {
                state.vesselListMsiValue.loading = false;
                state.vesselListMsiValue.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
            }
        },
        getVesselRecentSalesRequestAction: (state: TMsiValueSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.vesselListRecentSales) {
                state.vesselListRecentSales.loadingError = null;
                state.vesselListRecentSales.loading = true;
            }
        },
        getVesselRecentSalesSuccessAction: (
            state: TMsiValueSliceState,
            { payload: data }: PayloadAction<TVesselRecentSales[]>,
        ) => {
            if (state.vesselListRecentSales) {
                state.vesselListRecentSales.dataList = data;
                state.vesselListRecentSales.loading = false;
                state.vesselListRecentSales.loadingError = null;
            }
        },
        getVesselRecentSalesErrorAction: (
            state: TMsiValueSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.vesselListRecentSales) {
                state.vesselListRecentSales.loading = false;
                state.vesselListRecentSales.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
            }
        },
        getSummaryMsiValueRequestAction: (state: TMsiValueSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.summaryMsiValue) {
                state.summaryMsiValue.loading = true;
                state.summaryMsiValue.loadingError = null;
            }
        },
        getSummaryMsiValueSuccessAction: (
            state: TMsiValueSliceState,
            { payload: data }: PayloadAction<TSummaryMsiValue>,
        ) => {
            if (state.summaryMsiValue) {
                state.summaryMsiValue.dataList = data.dataList;
                state.summaryMsiValue.infoNote = data.infoNote;
                state.summaryMsiValue.loading = false;
                state.summaryMsiValue.loadingError = null;
            }
        },
        getSummaryMsiValueErrorAction: (
            state: TMsiValueSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.summaryMsiValue) {
                state.summaryMsiValue.loading = false;
                state.summaryMsiValue.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
            }
        },
    },
});

export const { getMsiValueRequestAction, getMsiValueSuccessAction, getMsiValueErrorAction, resetMsiValueAction,
    getVesselMsiValueRequestAction, getVesselMsiValueSuccessAction, getVesselMsiValueErrorAction,
    getVesselRecentSalesRequestAction, getVesselRecentSalesSuccessAction, getVesselRecentSalesErrorAction,
    getSummaryMsiValueRequestAction, getSummaryMsiValueSuccessAction, getSummaryMsiValueErrorAction
} =
    valueSlice.actions;
export default valueSlice.reducer;